import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Api} from "../../shared/api.service";
import {BaseInterface} from "../../shared/api/bases/api.models";
import {AccountsPerIpInterface, AccountsPerIp} from "../../shared/api/bases/proxy/statistics/receivers/api.models";
import {SettingInterface, ExpireSchema} from "../../shared/api/bases/proxy/settings/api.models";

@Component({
    selector : 'profiles-per-ip-level',
    template: require('./profilesPerIpLevel.component.html')
})

export class ProfilesPerIpLevelComponent implements OnInit {

    protected bases: BaseInterface[] = [];
    protected selectedBaseId: number;

    protected settings: ExpireSchema[] = [];
    protected accountsPerIp: AccountsPerIpInterface[] = [];

    protected totalAccountsPerIp: AccountsPerIp;

    protected isLoadingSettings: boolean      = true;
    protected isLoadingAccountsPerIp: boolean = true;

    constructor(private route: ActivatedRoute, private api: Api) {}

    ngOnInit() {
        this.bases          = this.route.snapshot.data['bases'];
        this.selectedBaseId = this.bases[0].id;
        this.loadBase();
    }

    protected loadBase() {
        this.isLoadingSettings      = true;
        this.isLoadingAccountsPerIp = true;
        this.totalAccountsPerIp     = null;

        this.api.bases().proxy(this.selectedBaseId).setting().resource('message_ip_expire_schema').subscribe((setting: SettingInterface) => {
            this.settings          = JSON.parse(setting.value) as ExpireSchema[];
            this.isLoadingSettings = false;
        });

        this.api.bases().proxy(this.selectedBaseId).statistics().receivers().accountsPerIp().subscribe((result: AccountsPerIpInterface[]) => {
            this.accountsPerIp          = result;
            this.totalAccountsPerIp = new AccountsPerIp();

            this.totalAccountsPerIp.accountCount = this.accountsPerIp.reduce((total, value) => total + value.accountCount, 0);
            this.totalAccountsPerIp.occurences   = this.accountsPerIp.reduce((total, value) => total + value.occurences, 0);
            this.totalAccountsPerIp['total']     = this.accountsPerIp.reduce((total, value) => total + (value.accountCount * value.occurences), 0);

            this.isLoadingAccountsPerIp = false;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/insights/profilesPerIpLevel/profilesPerIpLevel.component.ts